var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    staticClass: "form-group d-flex flex-column",
    attrs: {
      vid: _vm.name || _vm.label.toLowerCase(),
      name: _vm.label,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _vm.label.length > 0 && !errors[0]
              ? _c(
                  "label",
                  {
                    staticClass: "text-text-light small",
                    class: classes,
                    attrs: {
                      for: "id_" + (_vm.name || _vm.label.toLowerCase())
                    }
                  },
                  [_vm._v(_vm._s(_vm.label))]
                )
              : _vm._e(),
            _vm._v(" "),
            errors[0]
              ? _c("label", { staticClass: "text-status-error small" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "textarea"
              ? _c(
                  "textarea",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "form-control",
                      class: classes,
                      attrs: {
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "...",
                        cols: "3"
                      },
                      domProps: { value: _vm.localValue },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localValue = $event.target.value
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "date"
              ? _c(
                  "flat-pickr",
                  _vm._g(
                    {
                      staticClass: "form-control",
                      class: classes,
                      attrs: {
                        allowInput: true,
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "...",
                        config: _vm.config,
                        name: "date"
                      },
                      model: {
                        value: _vm.localValue,
                        callback: function($$v) {
                          _vm.localValue = $$v
                        },
                        expression: "localValue"
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "select"
              ? _c(
                  "v-select",
                  _vm._g(
                    {
                      class: classes,
                      attrs: {
                        options: _vm.options,
                        label: "post_title",
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "..."
                      },
                      model: {
                        value: _vm.localValue,
                        callback: function($$v) {
                          _vm.localValue = $$v
                        },
                        expression: "localValue"
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "checkbox"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "form-control",
                      class: classes,
                      attrs: {
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "...",
                        type: "checkbox"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.localValue)
                          ? _vm._i(_vm.localValue, null) > -1
                          : _vm.localValue
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.localValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.localValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.localValue = $$c
                          }
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "radio"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "form-control",
                      class: classes,
                      attrs: {
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "...",
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.localValue, null) },
                      on: {
                        change: function($event) {
                          _vm.localValue = null
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "form-control",
                      class: classes,
                      attrs: {
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || _vm.label + "...",
                        type: _vm.type
                      },
                      domProps: { value: _vm.localValue },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localValue = $event.target.value
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                ),
            _vm._v(" "),
            _vm.description.length > 0
              ? _c(
                  "small",
                  {
                    staticClass: "form-text text-text-light",
                    attrs: {
                      id: "description_" + (_vm.name || _vm.label.toLowerCase())
                    }
                  },
                  [_vm._v(_vm._s(_vm.description))]
                )
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }